import React from 'react';

/** Lazy ClientComputedCertificate (not wrapped in a suspense to use the parent widget loading fallback) */
export const ClientComputedCertificate = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'widget-learning-certificate' */
            './ClientComputedCertificate'
        ),
);
